import { supabase } from '../Supabase/supabaseRealtimeClient';

class NotificationService {
  private subscription: any = null;
  private isListening = false;

  // Iniciar monitoramento global de novos chamados e telemedicina
  startGlobalListening() {
    if (this.isListening) {
      return;
    }

    console.log('🚀 NotificationService: Iniciando monitoramento global');
    
    // Monitorar Chamados de Emergência
    const chamadosChannel = supabase
      .channel('global-notifications-' + Date.now())
      .on('postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'chamado'
        },
        (payload) => {
          console.log('🚨 Novo chamado detectado globalmente!');
          this.triggerNotification(payload.new);
        }
      )
      // Monitorar Telemedicina (Triagem)
      .on('postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'video_atendimentos'
        },
        (payload: any) => {
           // Novo chamado na triagem
           if (payload.eventType === 'INSERT' && payload.new.status === 'aguardando_triagem') {
               console.log('🚨 Nova triagem detectada globalmente!');
               this.triggerNotification(payload.new);
           }
          // Atualização para médico (encaminhamento) - REMOVIDO PARA SER LOCAL
          // if (payload.eventType === 'UPDATE' && payload.new.status === 'aguardando_medico' && payload.old && payload.old.status !== 'aguardando_medico') {
          //    console.log('🚨 Novo encaminhamento médico detectado globalmente!');
          //    this.triggerNotification(payload.new);
          // }
        }
      )
      .subscribe((status) => {
        if (status === 'SUBSCRIBED') {
          console.log('✅ NotificationService: Conectado ao realtime');
          this.isListening = true;
        }
      });
      
      this.subscription = chamadosChannel;
  }

  private triggerNotification(data: any) {
     // Tocar som
     try {
        const audio = new Audio("/assets/notification.mp3");
        audio.volume = 0.7;
        audio.play().catch(e => console.error('Error playing sound:', e));
     } catch (e) {
        console.error('Error creating audio:', e);
     }

     // Disparar evento global para UI
     const event = new CustomEvent('novaNotificacao', {
        detail: data
     });
     window.dispatchEvent(event);
  }

  // Parar monitoramento
  stopGlobalListening() {
    if (this.subscription) {
      console.log('🛑 NotificationService: Parando monitoramento global');
      supabase.removeChannel(this.subscription);
      this.subscription = null;
      this.isListening = false;
    }
  }

  // Verificar se está escutando
  isGlobalListening() {
    return this.isListening;
  }
}

// Instância singleton
export const notificationService = new NotificationService();
